import React from "react";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../../components/noData/noData";
import FilterBar from "./FilterBar";
import DataPoints from "./DataPoints";
import FreezeLifecyclePieChart from "./FreezeLifecyclePieChart";
import FreezeLifecycleTable from "./FreezeLifecycleTable";

const FreezeHistoryView = () => {
  const updatesLoading = useSelector((state) => state.freezeLifecycle.updatesLoading);
  const hasData = useSelector((state) => !!state.freezeLifecycle.chartsData.table?.data?.length);

  return (
    <div>
      <FilterBar isFreezeHistory />

      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : hasData ? (
          <>
            <div className="summary">
              <DataPoints />
              <FreezeLifecyclePieChart />
            </div>
            <FreezeLifecycleTable />
          </>
        ) : (
          <NoData />
        )}
      </div>
    </div>
  );
};

export default FreezeHistoryView;
